import React from 'react';
import { ActionContainer, ActionLink, ActionTitle } from '../../shared/styles';

export default function Actions() {
  return (
    <ActionContainer>
      <ActionTitle>Tools</ActionTitle>
      <ActionLink href="/lwadmin/homepage/banner/new">Create Banner</ActionLink>
    </ActionContainer>
  );
}
